import { demandConstants } from "./types";
import { addFeedback, getMyDemand, askToAgent,getMemberFek, getMemberIban} from "../../../services/workflow.service";
import { alertActions, loading } from "../alert/actions";
import { beginLogout } from "../login/actions";

const endError = error => {
  return dispatch => {
    dispatch(loading.hideLoading());
    if (error?.response?.status === 401 || error?.message === "Network Error") {
      dispatch(beginLogout());
    } else {
      dispatch(alertActions.error(error));
      dispatch({
        type: demandConstants.DEMANDS_ERROR,
        error
      });
    }
  };
};

const addFeedbacks = (konu, aciklama, basvuruNedeni, uyeNo, adiSoyadi, tckn, babaAdi, unvan, vkn, mersisNo, iban, phone) => {
  return dispatch => {
    dispatch(request("addFeedbacks"));
    dispatch(loading.showLoading());
      addFeedback(konu, aciklama, basvuruNedeni, uyeNo, adiSoyadi, tckn, babaAdi, unvan, vkn, mersisNo, iban, phone).then(
      feedback => {
        dispatch(loading.hideLoading());
        dispatch(success(feedback));
      },
      error => {
        dispatch(endError(error));
      }
    );
  };
  function request(feedback) {
    return {
      type: demandConstants.ADD_FEEDBACK_REQUEST,
      payload: { feedback }
    };
  }
  function success(feedback) {
    return {
      type: demandConstants.ADD_FEEDBACK_SUCCESS,
      payload: { feedback }
    };
  }
};

const askToAgents = (konu, aciklama) => {
  return dispatch => {
    dispatch(request("askToAgents"));
    dispatch(loading.showLoading());
    askToAgent(konu, aciklama).then(
      feedback => {
        dispatch(loading.hideLoading());
        dispatch(success(feedback));
      },
      error => {
        dispatch(endError(error));
      }
    );
  };
  function request(agent) {
    return {
      type: demandConstants.ASK_TO_AGENT_REQUEST,
      payload: { agent }
    };
  }
  function success(agent) {
    return {
      type: demandConstants.ASK_TO_AGENT_SUCCESS,
      payload: { agent }
    };
  }
};

const clearSuccessMessage = () => {
  return {
    type: demandConstants.CLEAR_SUCCESS_MESSAGE,
    payload: {  }
  };
};

const getMyDemands = () => {
  return dispatch => {
    dispatch(request());
    dispatch(loading.showLoading());
    getMyDemand().then(
      response => {
        dispatch(success(response.data));
        dispatch(loading.hideLoading());
      },
      error => {
        dispatch(endError(error));
      }
    );
  };
  function request() {
    return {
      type: demandConstants.GET_MY_DEMANDS_REQUEST,
      payload: {}
    };
  }
  function success(data) {
    return {
      type: demandConstants.GET_MY_DEMANDS_SUCCESS,
      payload: { list: data }
    };
  }
};
const getMemberFeks = (basvuruNedeni) => {
  return dispatch => {
    dispatch(request());
    dispatch(loading.showLoading());
    getMemberFek(basvuruNedeni).then(
      response => {
        dispatch(success(response.data));
        dispatch(loading.hideLoading());
      },
      error => {
        dispatch(endError(error));
      }
    );
  };

  function request() {
    return { type: demandConstants.GET_MEMBER_FEK_REQUEST };
  }
  function success(data) {
    return { type: demandConstants.GET_MEMBER_FEK_SUCCESS, payload: { memberFek: data } };
  }
};

const getMemberIbans = () => {
  return dispatch => {
    dispatch(request());
    dispatch(loading.showLoading());
    getMemberIban().then(
      response => {
        dispatch(success(response.data));
        dispatch(loading.hideLoading());
      },
      error => {
        dispatch(endError(error));
      }
    );
  };

  function request() {
    return { type: demandConstants.GET_MEMBER_IBAN_REQUEST };
  }
  function success(data) {
    return { type: demandConstants.GET_MEMBER_IBAN_SUCCESS, payload: { memberIban: data } };
  }
};

const clearMemberFek = () => {
  return {
    type: demandConstants.CLEAR_MEMBER_FEK,
    payload: []
  };
};

const clearMemberIban = () => {
  return {
    type: demandConstants.CLEAR_MEMBER_IBAN,
    payload: []
  };
};

export { addFeedbacks, getMyDemands, askToAgents, clearSuccessMessage, getMemberFeks , clearMemberFek, getMemberIbans, clearMemberIban};
